import React from 'react';

const MapSection = () => {
    return (
        <section className="wpo-map-section">
            <h2 className="hidden">Contact map</h2>
            <div className="wpo-map">
                <iframe title="Map Location"
                    src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d25211.27116251022!2d144.8450722!3d-37.8273123!3m2!1i1024!2i768!4f13.1!2m1!1smap%20location%20of%20BAY%206%20BLACKSHAWS%20RD%20ALTONA%20NORTH%20VIC!5e0!3m2!1sen!2sin!4v1772029394925!5m2!1sen!2sin"
                    ></iframe>
            </div>
        </section>
    );
};

export default MapSection;